// 토스트 캐릭터 아바타 사전 로드 (2026-09-02)
//
// 왜: 게임 계열 토스트는 캐릭터 얼굴이 화자다. 그런데 이미지를 토스트가 뜨는 순간
//     처음 요청하면 네트워크 왕복 동안 회색 원만 보인다 — 화자가 없는 알약이 뜬다.
// 어떻게: 앱이 한가해진 뒤(requestIdleCallback) 토스트가 실제로 쓰는 5장만 미리 받는다.
//         192px 썸네일 기준 약 200KB — 부팅을 막지 않고 첫 화면 로딩과 경쟁하지도 않는다.
// ⚠ 배역이 바뀌면(ToastHost의 CAST_BY_KIND) 여기 목록도 함께 바꿀 것.
import { CAST, avatarThumbSrc } from '../redesign/_components/cast';

/** [캐릭터 id, 표정] — ToastHost의 CAST_BY_KIND × EXPR_BY_KIND(+호출부 expr 덮어쓰기) 조합 */
const TOAST_FACES: Array<[string, string]> = [
  ['hwangdoongi', 'celebrate'],  // levelup
  ['roki', 'confident'],         // achievement 기본
  ['roki', 'celebrate'],         // achievement — showAchievementToast가 celebrate로 덮는다
  ['kongi', 'confident'],        // attendance
  ['bbiyong', 'celebrate'],      // quest
];

let done = false;

/** 유휴 시간에 토스트 캐릭터 얼굴을 브라우저 캐시에 올린다. 앱당 1회. */
export function preloadToastCast(): void {
  if (done || typeof window === 'undefined') return;
  done = true;

  const run = () => {
    for (const [id, expr] of TOAST_FACES) {
      const dir = (CAST as Record<string, { dir?: string }>)[id]?.dir;
      if (!dir) continue;   // 배역이 바뀌어 없는 id가 남아도 조용히 건너뛴다
      const img = new Image();
      img.decoding = 'async';
      img.src = avatarThumbSrc(dir, expr);
    }
  };

  // requestIdleCallback이 없는 사파리 구버전은 지연 실행으로 대체한다.
  const ric = (window as { requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => void })
    .requestIdleCallback;
  if (typeof ric === 'function') ric(run, { timeout: 3000 });
  else window.setTimeout(run, 1200);
}
